import { VerifyEmailPage } from './VerifyEmailPage';

export const verifyEmailRouter = {
  '/@/verify_email': VerifyEmailPage,
};
